<template>
  <div id="wrapper" :class="{toggled: !sidebarCollapsed && showNavigation, 'no-navigation': hideNavigation}">
    <div id="sidebar-wrapper" v-if="showNavigation">
      <navigation-left></navigation-left>
    </div>

    <div id="page-content-wrapper">
      <navigation-top v-show="showNavigation"></navigation-top>
      <div style="position:relative; z-index: 3">
        <breadcrumbs v-if="showNavigation && breadcrumbs && breadcrumbs.length" />
      </div>
      <div class="container-fluid mt-3" id="main" :class="{'logged-in': loggedInUser}">
        <router-view />
      </div>
    </div>

    <notifications animation-type="velocity"/>
    <ConfirmDialog/>
    <LoadingDialog/>
    <LoginPrompt/>
    <AlertsHandler/>
    <Differences/>
  </div>
</template>

<script>
import NavigationTop from './navigation/NavigationTop.vue'
import NavigationLeft from './navigation/NavigationLeft.vue'
import Breadcrumbs from './navigation/Breadcrumbs'
import userInfoMixin from '@/common/mixins/user-info-mixin'
import ConfirmDialog from '@/common/dialogs/ConfirmDialog.vue'
import LoadingDialog from '@/common/dialogs/LoadingDialog.vue'
import LoginPrompt from '@/login/LoginPrompt'
import AlertsHandler from '@/common/elements/AlertsHandler'
import Differences from '@/common/elements/Differences'

import _ from 'lodash'
import { SettingsFactory } from '@/common/utils/SettingsFactory'
import trackingService from './common/utils/tracking-service.js'
import VueGtag from 'vue-gtag'
import Vue from 'vue'

export default {
  name: 'app',
  mixins: [userInfoMixin],
  components: {
    AlertsHandler,
    LoginPrompt,
    ConfirmDialog,
    LoadingDialog,
    Breadcrumbs,
    NavigationTop,
    NavigationLeft,
    Differences
  },
  computed: {
    sidebarCollapsed () {
      return this.$store.state.main.sidebarCollapsed
    },
    breadcrumbs () {
      return this.$store.state.main.breadcrumbs
    },
    // A route opts out of the application navigation with meta.hideNavigation,
    // e.g. the third-party authorization page (TPOS-9749).
    hideNavigation () {
      return this.$route.matched.some(record => record.meta.hideNavigation)
    },
    showNavigation () {
      return !!this.loggedInUser && !this.hideNavigation
    }
  },
  // watch: {
  //   '$route': () => {
  //     window.Appcues.page()
  //   }
  // },
  created () {
    // eslint-disable-next-line no-new
    const settingsFactory = new SettingsFactory()
    SettingsFactory.instance = settingsFactory

    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },
  mounted () {
    this.onResize()
    this.initTracking()
  },
  methods: {
    onResize: _.debounce(function () {
      this.$store.commit('SET_CLIENT_DIMENSIONS', { height: window.innerHeight, width: window.innerWidth })
    }),
    initTracking () {
      trackingService.settings()
        .then(settings => {
          if (settings.googleAnalyticsKey) {
            Vue.use(VueGtag, {
              config: { id: settings.googleAnalyticsKey }
            }, this.$router)
          }
        })
        .catch(err => {
          console.debug('Problem fetching tracking keys.')
          console.warn(err)
        })
    }
  }
}
</script>

<style lang="scss">
  @import "@/assets/scss/styles.scss";
</style>
